import * as pm from '@tarslib/collection';
import { lodash } from '@tarslib/collection/lib/util';
import SocketItem from './SocketItem.js';
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t, "prototype", {
    writable: false
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HttpItem = /*#__PURE__*/function (_pm$Item) {
  function HttpItem(definition) {
    var _definition$metaInfo;
    var _this;
    _classCallCheck(this, HttpItem);
    // @ts-ignore
    _this = _callSuper(this, HttpItem, [definition]);
    _defineProperty(_this, "type", 'http');
    if (definition !== null && definition !== void 0 && definition.responseDefinition) {
      _this.responseDefinition = definition.responseDefinition;
    }
    if (definition !== null && definition !== void 0 && definition.requestDefinition) {
      _this.requestDefinition = definition.requestDefinition;
    }
    if (definition !== null && definition !== void 0 && definition.overrideRequesterOptions) {
      _this.overrideRequesterOptions = definition.overrideRequesterOptions;
    }
    _this.metaInfo = (_definition$metaInfo = definition === null || definition === void 0 ? void 0 : definition.metaInfo) !== null && _definition$metaInfo !== void 0 ? _definition$metaInfo : {};
    return _this;
  }
  _inherits(HttpItem, _pm$Item);
  return _createClass(HttpItem, [{
    key: "clone",
    value: function clone() {
      return new HttpItem(this.toJSON());
    }
  }], [{
    key: "isHttpItem",
    value: function isHttpItem(obj) {
      return Boolean(obj) && (obj instanceof HttpItem || lodash.inSuperChain(obj.constructor, '_postman_propertyName', HttpItem._postman_propertyName));
    }
  }, {
    key: "isItem",
    value: function isItem(obj) {
      return HttpItem.isHttpItem(obj) || SocketItem.isSocketItem(obj) || pm.Item.isItem(obj);
    }
  }]);
}(pm.Item);
_defineProperty(HttpItem, "_postman_propertyName", 'Item');
export { HttpItem as default };
